/**
 * Announcement Services
 * Services for announcement management operations
 */
// Export all service classes
export { AnnouncementService } from './AnnouncementService';
export { AnnouncementStatusService } from './AnnouncementStatusService';
export { AnnouncementTypeService } from './AnnouncementTypeService';
export { AnnouncementCategoryService } from './AnnouncementCategoryService';
export { AnnouncementPriorityService } from './AnnouncementPriorityService';
export { AnnouncementAudienceService } from './AnnouncementAudienceService';
export { AnnouncementMediaTypeService } from './AnnouncementMediaTypeService';
export { RecurrenceTypeService } from './RecurrenceTypeService';
export { AnnouncementLinkTypeService } from './AnnouncementLinkTypeService';
export { AnnouncementTagLookupService } from './AnnouncementTagLookupService';
export { AnnouncementLocationService } from './AnnouncementLocationService';
export { AnnouncementEventService } from './AnnouncementEventService';
export { AnnouncementMediaService } from './AnnouncementMediaService';
export { AnnouncementLinkService } from './AnnouncementLinkService';
export { AnnouncementTagService } from './AnnouncementTagService';
export { AnnouncementLogService } from './AnnouncementLogService';
export { AnnouncementAnalyticService } from './AnnouncementAnalyticService';
export { PublicAnnouncementService } from './PublicAnnouncementService';
// Import for factory function
import { AnnouncementService } from './AnnouncementService';
import { AnnouncementStatusService } from './AnnouncementStatusService';
import { AnnouncementTypeService } from './AnnouncementTypeService';
import { AnnouncementCategoryService } from './AnnouncementCategoryService';
import { AnnouncementPriorityService } from './AnnouncementPriorityService';
import { AnnouncementAudienceService } from './AnnouncementAudienceService';
import { AnnouncementMediaTypeService } from './AnnouncementMediaTypeService';
import { RecurrenceTypeService } from './RecurrenceTypeService';
import { AnnouncementLinkTypeService } from './AnnouncementLinkTypeService';
import { AnnouncementTagLookupService } from './AnnouncementTagLookupService';
import { AnnouncementLocationService } from './AnnouncementLocationService';
import { AnnouncementEventService } from './AnnouncementEventService';
import { AnnouncementMediaService } from './AnnouncementMediaService';
import { AnnouncementLinkService } from './AnnouncementLinkService';
import { AnnouncementTagService } from './AnnouncementTagService';
import { AnnouncementLogService } from './AnnouncementLogService';
import { AnnouncementAnalyticService } from './AnnouncementAnalyticService';
import { PublicAnnouncementService } from './PublicAnnouncementService';
/**
 * Create all announcement services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all announcement services
 */
export function createAnnouncementServices(http, config) {
    return {
        announcement: new AnnouncementService(http, config),
        announcementStatus: new AnnouncementStatusService(http, config),
        announcementType: new AnnouncementTypeService(http, config),
        announcementCategory: new AnnouncementCategoryService(http, config),
        announcementPriority: new AnnouncementPriorityService(http, config),
        announcementAudience: new AnnouncementAudienceService(http, config),
        announcementMediaType: new AnnouncementMediaTypeService(http, config),
        recurrenceType: new RecurrenceTypeService(http, config),
        announcementLinkType: new AnnouncementLinkTypeService(http, config),
        announcementTagLookup: new AnnouncementTagLookupService(http, config),
        announcementLocation: new AnnouncementLocationService(http, config),
        announcementEvent: new AnnouncementEventService(http, config),
        announcementMedia: new AnnouncementMediaService(http, config),
        announcementLink: new AnnouncementLinkService(http, config),
        announcementTag: new AnnouncementTagService(http, config),
        announcementLog: new AnnouncementLogService(http, config),
        announcementAnalytic: new AnnouncementAnalyticService(http, config),
        publicAnnouncement: new PublicAnnouncementService(http, config),
    };
}
//# sourceMappingURL=index.js.map